import { useEffect, useState } from "react";
import ReUse from "../../services/helpers/reUse";

export const SellerAddProduct = (attributes = {}) => {
  // const attributes = {
  //     color: ["red", "blue"],
  //     size: ["small", "medium"],
  // };

  const generateVariations = (attributes) => {
    const keys = Object.keys(attributes);

    const attributeOptions = keys.map((key) => attributes[key]);

    const variations = generateCartesianProduct(...attributeOptions)?.map(
      (combination, index) => {
        const variation = {};
        combination?.forEach((option, i) => {
          variation[keys[i]] = option;
        });
        return {
          [`variation${index + 1}`]: Object?.values(variation)?.join("-"),
        };
      }
    );

    return variations;
  };

  function generateCartesianProduct(...sets) {
    /**
     * sets argument structure
     * var attributes = {
     * color: ["red", "blue"],
     * size: ["small", "medium"],
     * measure: ["10cm", "20cm"]
     * };
     *
     */
    // console.log(sets ,"bjaisets")
    return sets?.reduce(
      (acc, set) => {
        return acc?.flatMap((x) => set?.map((y) => [...x, y]));
      },
      [[]]
    );
  }

  const generatedVariations = generateVariations(attributes);
  // console.log(generatedVariations, "sdlkksd0ie");

  const useVariantDataHandler = () => {
    const [variantData, setVariantData] = useState([]);
    const [metaData, setMetaData] = useState([]);
    console.log("metaData hook",generatedVariations,metaData);
    const [bulkVariantData, setBulkVariantData] = useState([]);
    const [bulkVariantMOQs, setBulkVariantMOQs] = useState([]);
    const [bulkVariantAddFieldsData, setBulkVariantAddFieldsData] = useState(
      []
    );
    console.log(
      bulkVariantData,
      bulkVariantMOQs,
      bulkVariantAddFieldsData,
      "roiwi3"
    );

    console.log(generatedVariations,"generatemywariii")
    useEffect(()=>{
      setMetaData((preVal) =>{
        return generatedVariations?.map((val,index) => {
          console.log("metaData hook ",val[`variation${index+1}`])
        let metaFind = preVal?.find((val)=>val?.slug === val[`variation${index+1}`]);
          return (metaFind)? {...metaFind} : {
            slug : val[`variation${index+1}`],
            qty : 1,
            sku : '',
            rows : [{
              maxQty : 0,
              minQty : 1,
              price : 0
            }]
          }
        })
      })
      console.log("generatedVariations",generatedVariations);
    },[0])

    // const variantDataHandler = (e, index) => {
    //   const { name, value } = e.target;

    //   const isNumberOrText = ReUse.isNumberOrText({ stringInput: value });

    //   const newVarientData = [...variantData];

    //   const key = newVarientData?.findIndex((value,key) => key === parseInt(index));

    //   if(key >= 0){
    //       newVarientData[index] = {
    //         ...variantData[key],
    //         [name] : value
    //       };
    //     }else{
    //       newVarientData.push({
    //         [name] : value
    //       });
    //     }

    //     setVariantData(variantData);

    //     // setVariantData((prevData) => {

    //     // const newData = [...prevData];
    //     // newData[index] = {
    //     //   ...newData[index],
    //     //   [name]: isNumberOrText ? parseInt(value) : value,
    //     // };
    //     // console.log("prevData",newData);
    //     // return newData;
    //   // });
    // };
    // console.log("varient Data",variantData);
    const variantDataHandler = (e, index) => {
      e.preventDefault();
      const { name, value } = e.target;
      console.log(name, value, "sdokosd33434q");
      const isNumberOrText = ReUse.isNumberOrText({ stringInput: value });
      setVariantData((prevData) => {
        const newData = [...prevData];
        console.log(newData, "newdata");
        newData[index] = {
          ...newData[index],
          [name]: isNumberOrText ? parseInt(value) : value,
        };
        return newData;
      });
    };
    // ==============================================================================
    const onChangeMetaRowHandler = (e,slug,getRowIndex) => {
      const {name , value} = e.target;
      setMetaData((preVal)=>{
        let newData = [...preVal?.map((val,index)=>{
          if(val?.slug === slug){
            return {
              ...val,
              rows : [
                ...val?.rows?.map((row,rowIndex)=>{
                  if(rowIndex === getRowIndex){
                    return {...row , [name] : value}
                  }else { 
                    return row;
                  }
                })
              ]
            }
          }else{
            return val
          }
        })];
        // setParentMeta((preVal)=>[...newData]);
        return newData
      });
      // console.log("meta",meta)
      // if(meta?.length > 0){
      //   // localStorage.setItem("meta", JSON.stringify(meta) );
      //   // dispatch(ProductsFilterActions.setMeta(meta));
      // }
    }
  
    const onChangeMetaHandler = (e,slug) => {
      const {name , value} = e.target;
      setMetaData((preVal)=>{
        let newData = [...preVal?.map((val,index)=>{
          if(val?.slug === slug){
            return {
              ...val,
              [name] : value
            }
          }else{
            return val
          }
        })];
        return newData
      });
      // if(meta?.length > 0){
      //   // localStorage.setItem("meta", JSON.stringify(meta) );
      //   // dispatch(ProductsFilterActions.setMeta(meta));
      // }
    }
    const onAddRowMetaHandler = (e,slug) => {
      setMetaData((preVal)=>{
        let newData = [...preVal?.map((val,index)=>{
          if(val?.slug === slug){
            let newRows = [...val?.rows];
            (newRows?.length < 4) && newRows.push({
              maxQty : 0,
              minQty : 1,
              price : 0
            });
            return {
              ...val,
              rows : [...newRows]
            }
          }else{
            return val
          }
        })];
        return newData
      });
      // if(meta?.length > 0){
      //   // localStorage.setItem("meta", JSON.stringify(meta) );
      //   // dispatch(ProductsFilterActions.setMeta(meta));
      // }
    }
    // ================= META DATA HANDLER ==========================================

    // const variantDataHandler = (e, index) => {
    //   const { name, value } = e.target;
    //   console.log(name, value, "sdokosd33434q");
    //   const isNumberOrText = ReUse.isNumberOrText({ stringInput: value });

    //   setVariantData((prevData) => {
    //     const newData = [...prevData];
    //     const key = newData?.findIndex((value,key) => key === parseInt(index));
    //     console.log(key,"mykey")

    //     if(key !== 0) {
    //       newData[index] = {
    //         ...newData[index],
    //         [name]: isNumberOrText ? parseInt(value) : value,
    //       };
    //     }

    //     return newData;
    //   });
    // };

    const bulkVariantDataHandler = (e, index) => {
      // OUTPUT EXAMPLE  const data = [
      // 	{
      // 		qty: 10,
      // 		sku: "red",
      // 		moqs: [
      // 			{
      // 				moq: 100,
      // 				price: 1000,
      // 			},
      // 		],
      // 	},
      // ];

      const { name, value } = e.target;
      const isNumberOrText = ReUse.isNumberOrText({ stringInput: value });
      setBulkVariantData((prevData) => {
        const newData = [...prevData];

        newData[index] = {
          ...newData[index],
          [name]: isNumberOrText ? parseInt(value) : value,
          moqs: [],
        };
        return newData;
      });
    };

    const variantMOQsHandler = ({ event, index, variantTitle }) => {
      const { name, value } = event.target;
      const isNumberOrText = ReUse.isNumberOrText({ stringInput: value });

      setBulkVariantAddFieldsData((prevData) => {
        const newData = [...prevData];
        const nestedData = [...(prevData[index] || [])];
        const comingData = {
          index,
          variantTitle,
          // moq: isNumberOrText && name === "moq" ? parseInt(value) : 1,
          minimoq: isNumberOrText && name === "minimoq" ? value : 1,
          maximoq: isNumberOrText && name === "maximoq" ? value : 1,
          price: isNumberOrText && name === "price" ? value : 100,
        };
        nestedData.push(comingData);
        newData[index] = nestedData;
        return newData;
      });
    };
    // -===============================================================================

    



    // const variantMOQsHandler = ({ event, index, variantTitle }) => {
    //   console.log(event, "eventpoo");
    //   const { name, value } = event.target;
    //   console.log(name, value, "ppoopo");
    //   const isNumberOrText = ReUse.isNumberOrText({ stringInput: value });
    //   setBulkVariantAddFieldsData((prevData) => {
    //     console.log(prevData, "pichay say detaa");
    //     const newData = [...prevData];
    //     const nestedData = [...(prevData[index] || [])];
    //     console.log(nestedData, "mynested");
    //     const existingObjectIndex = nestedData?.findIndex(
    //       (item) => item?.index === index
    //     );
    //     console.log(existingObjectIndex, "checkplesemyindex");
    //     if (existingObjectIndex !== -1) {
    //       nestedData[existingObjectIndex][name] = isNumberOrText
    //         ? parseInt(value)
    //         : value;
    //     } else {
    //       const comingData = {
    //         index,
    //         variantTitle,
    //         moq: isNumberOrText && name === "moq" ? parseInt(value) : 1,
    //         price: !isNumberOrText && name === "price" ? value : 100,
    //       };
    //       nestedData.push(comingData);
    //     }
    //     newData[index] = nestedData;
    //     return newData;
    //   });
    // };

    return [
      variantData,
      variantDataHandler,
      bulkVariantData,
      bulkVariantDataHandler,
      bulkVariantMOQs,
      variantMOQsHandler,
      bulkVariantAddFieldsData,
      metaData,
      setMetaData,
      onChangeMetaRowHandler,
      onChangeMetaHandler,
      onAddRowMetaHandler
    ];
  };

  return {
    generatedVariations,
    useVariantDataHandler,
  };
};

// const selectedAttributes = [
//     {
//         attribute: "color",
//         values: [
//             { value: "sdsds", label: "sdsds" },
//             { value: "sds", label: "sdds" },
//         ],
//     },
//     {
//         attribute: "green",
//         values: [
//             { value: "sdsds", label: "sdsds" },
//             { value: "sds", label: "sdds" },
//         ],
//     },
// ];
